import { render, staticRenderFns } from "./TagsController.vue?vue&type=template&id=e94eddba&scoped=true&"
import script from "./TagsController.vue?vue&type=script&lang=ts&"
export * from "./TagsController.vue?vue&type=script&lang=ts&"
import style0 from "./TagsController.vue?vue&type=style&index=0&id=e94eddba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94eddba",
  null
  
)

export default component.exports